import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { AspOrderListService } from '../asp-order-list/asp-order-list.service';
import { Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ToastrService } from 'ngx-toastr';
import { AspReturnItemsComponent } from '../asp-return-items/asp-return-items.component';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AspInstantOrderQuoteService } from '../asp-instant-order-quote/asp-instant-order-quote.service';


@Component({
  selector: 'app-asp-order-details',
  templateUrl: './asp-order-details.component.html',
  styleUrls: ['./asp-order-details.component.scss']
})
export class AspOrderDetailsComponent implements OnInit {
  @Input() order: any;
  @Input() isVisible: boolean = false;

  images = {
    'Confirmed': "assets/images/order-details/confirmed.png",
    'Packed': "assets/images/order-details/packed.png",
    'On The Way': "assets/images/order-details/way.png",
    'Delivered': "assets/images/order-details/delivered.png",
    'Cancelled': "assets/images/order-details/cancellednew.png"
  };
  showItemCancelSuccessPopup = false;
  cancelledItemName = '';
  orderDetails: any = [];
  count: any = 0;
  currentStatus: any = '';
  invoiceUrl: string | undefined; 
  showOrderCancelSuccessPopup = false;
  cancelledOrderId = '';
  showOrderCancelPopup = false;
  statuses = ['orderConfirm', 'orderPacked', 'orderOnTheWay', 'orderDelivery'];
  statusNames = ['Order Confirmed', 'Packed', 'On The Way', 'Delivered'];
  statusDates: { [key: string]: string } = {};
  currentStatusIndex: number = -1;
  orderDeliveryTimeFormatted: string = '';
  trackingUrl:  string | undefined;
  orderKey: any;
  addedCart: any;
  orderNumber: any;
  spareSelectedGarageName: any;
  isMobile: boolean;
  isBottomSheetOpen: boolean;
  isDownloadBottomSheet: boolean;
  deliveries: string[] = [];
  deliveryData: any = {};
  selectedDelivery: string;
  invoice: any;
  isLockedPopupOpen = false;
  selectedLockedItem: any = null;
  showRight = false;
 private initialCheckDone = false;
  returnDate: any;
  dueDate: boolean;
  resDateOnly: any;
  trackItem: boolean;
  stageOneDate: any;
  stageTwoText: string;
  stageTwoStatus: string;
  stageThreeActive: boolean;
  returnData: any;
  lateReturnRef!: MatBottomSheetRef<any>;
  isLateReturnSheetOpen: boolean = false;
  showLateReturnSheet: boolean = false;
  orderDeliveryTime: any;
  orderStatus: any;
  hours: number;
  orderDeliveredStatus: any;
  item: any;
  timelinedata: any;
  timelineData: any;
  packageTimelineData: any[];
  orderPackageId: any;
  selectedCancelItem: any = null;
returnItems = {
    id: 'RET-2024-003',
    createdDate: 'Jan 8, 2024',
    shippedDate: 'Jan 9, 2024',
    receivedDate: 'Jan 10, 2024',
    refundedDate: 'Jan 12, 2024',
    status: 'Declined', // can be 'Pending', 'Processing', 'Declined'
    reason: 'No longer needed',
    item: 'Engine Oil Filter - Premium Grade',
    salesOrder: 'SO-2024-0045',
    orderDate: 'Jan 5, 2024',
    creditNoteAvailable: true,
    declineReason: ''
  };
  statusInfo: any;
  returnWindowType: string;
  currentselectedDelivery: any;
  freeShipping: boolean;
  invoiceNumber: any;
  orderDate: any;
  showRegisterSheet: boolean = false;
  submitted = false;
  showSuccessPopup = false;
  registeredData: any = null;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  registerForm = this.fb.group({
    name: [
      '',
      [
        Validators.required,
        Validators.maxLength(20)   // name max 20 chars
      ]
    ],
    mobile: [
      '',
      [
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/)  // 10-digit Indian numbers only
      ]
    ],
    regno: ['', Validators.required],
    odometer: ['', Validators.required]
  });
  packageId: any;
  showBrandButton: any;
  showCancelItemPopup: boolean;
  showLastItemDeletePopup: boolean;
  lastItemDeleteIndex: number | null = null;
  lastItemName = '';
  constructor(
    private aspOrderListService: AspOrderListService,
    private router: Router,
    private bottomSheet: MatBottomSheet,
    private breakpointObserver: BreakpointObserver,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef,
    private resolver: ComponentFactoryResolver,
    private aspLoadingService: AspLoadingService,
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
     private aspInstantOrderQuoteService: AspInstantOrderQuoteService,
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); }
  @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;
  @ViewChildren('deliveryToggle', { read: ElementRef })
deliveryToggles!: QueryList<ElementRef>;
@ViewChild('tabScrollContainer') tabScrollContainer: ElementRef;
@ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
@ViewChild('lateReturnSheet') lateReturnSheet!: TemplateRef<any>;
  ngOnInit() {
    localStorage.removeItem("redeemCart");
    if (this.order && this.order.key) {
      this.getOrderDetails(this.order.key);
      this.getReorder(this.order.key);
    }
    this.spareSelectedGarageName = localStorage.getItem("spareSelectedGarageName");
  }



closeSidebar(ishide: boolean) {
  this.isVisible = ishide;
  // console.log("this.isVisible:", this.isVisible);
}
  
  openBottomSheet(): void {
    if(this.orderDetails.slotTag==null ){
      this.bottomSheet.open(this.bottomSheetTemplate,{
        panelClass: 'custom-bottom-sheet'
      }
      );
    }else{
      this.freeShipping=true;
    }
   
    
  }
  closeShipping(){
     this.freeShipping=false;
  }
  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }

  getOrderDetails(key: string) {
    this.orderKey=key;
     this.aspLoadingService.show();

      this.aspOrderListService.getorderdetails(key).subscribe(
        res => {
          this.aspLoadingService.hide();
          // (res['data'].orderItems || []).forEach((item: any) => {
          //   if (item.partNumber) {
          //     item.partNumber = item.partNumber.toUpperCase();
          //   }
          // });

          // (res['data'].packageDetails || []).forEach((pkg: any) => {
          //   (pkg.items || []).forEach((item: any) => {
          //     if (item.partNumber) {
          //       item.partNumber = item.partNumber.toUpperCase();
          //     }
          //   });
          // });

          // (res['data'].backOrders || []).forEach((order: any) => {
          //   (order.items || []).forEach((item: any) => {
          //     if (item.partNumber) {
          //       item.partNumber = item.partNumber.toUpperCase();
          //     }
          //   });
          // });
          // console.log('order-details-res',res);
          let gmtTime = res['data'].orderDeliveryTime;
          if (gmtTime) {
            let isoString = gmtTime.replace(' ', 'T') + 'Z';
            let date = new Date(isoString);

            date.setMinutes(date.getMinutes() + 330);
            this.orderDeliveryTime = date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
          } else {
            this.orderDeliveryTime = null;
          }
          this.orderStatus = res['data'].orderDelivery;
          // console.log("888888888888888888888",this.orderDeliveryTime)
          this.orderDetails = res['data'];
          // console.log('packageDetails:', res['data'].packageDetails);
          // console.log('packageDetails length:', res['data'].packageDetails.length);
          // console.log('backOrders:', res['data'].backOrders);
          // console.log('backOrders length:', res['data'].backOrders.length);
          // console.log('orderItems:', res['data'].orderItems);
          this.checkBrandButton(this.orderDetails)
          if (this.orderDetails.registrationNumber) {
            this.registerForm.controls['regno'].setValue(this.orderDetails.registrationNumber);
            this.registerForm.controls['regno'].disable();   // make it non-editable
          } else {
            this.registerForm.controls['regno'].enable();    // allow manual input
          }
          this.orderNumber = res['data'].orderNumber;
          this.invoiceNumber = res['data'].invoice?.[0]?.invoiceNumber;
          this.orderDate = res['data'].orderDate;
          // console.log('poEdt',this.orderDetails.poEdt);
          //  console.log('orderConfirmTime',this.orderDetails.orderConfirmTime);
          this.orderDeliveredStatus = res['data'].orderCurrentStatus;
          // console.log('orderStatus:', this.orderDetails?.orderStatus, '| orderDeliveredStatus:', this.orderDeliveredStatus);

          // console.log("this.orderDeliveredStatus----",this.orderDeliveredStatus);
          this.hours = this.calculateHoursFromNow(this.orderDetails.orderDeliveryTime);
          // console.log("Hours since order confirm:", this.hours);
          this.count = res['data'].orderItems.length;
          // this.setCurrentStatus(res['data']);
          // this.trackingUrl= res['data'].trackingUrl;
          this.trackingUrl = res['data']?.packageDetails?.[0]?.trackingUrl || null;
          this.orderNumber=res['data'].orderNumber;
          if (res['data'].packageDetails.length <= 0) {
          const orderItems: any[] = res['data'].orderItems || [];
            const orderItemMap: Map<string, any> = new Map(
              orderItems.map((item: any) => [item.partNumber, item])
            );
          // Create a Map for fast lookup
              const orderItemsMap = new Map(orderItems.map(item => [item.partNumber, item]));

              // Inject itemInfo at the backOrders level
              res['data'].backOrders.forEach(order => {
                const matchedItems = order.items
                  .map(i => orderItemsMap.get(i.partNumber))
                  .filter(Boolean); // remove undefined if not matched

                order.itemInfo = matchedItems;
              });

              // console.log("backorders----",res['data'].backOrders);
                      const backOrders = res['data'].backOrders.flatMap(pkg => pkg.items);
            // res['data'].notBackorderItems = res['data'].orderItems.filter(orderItem =>
            //   !backOrders.some(packedItem => packedItem.partNumber === orderItem.partNumber)
            // );
            if (res['data'].backOrders.length > 0) {
              res['data'].notBackorderItems = res['data'].orderItems.filter(orderItem =>
                !backOrders.some(packedItem => packedItem.partNumber === orderItem.partNumber)
              );
            } else {
              res['data'].notBackorderItems = [];
            }
          }

          //         const orderItems = res['data'].orderItems || [];
          //         const packageDetails = res['data'].packageDetails || [];
          //         this.deliveries = [];
          // this.deliveryData = {};

          // // 1. CANCELLED TAB (ALWAYS CHECK FIRST)
          // const cancelledItems = (orderItems || []).filter(
          //   (item: any) => item.cancelledQuantity && item.cancelledQuantity > 0
          // );

          // if (cancelledItems.length > 0) {
          //   this.deliveries.push('Cancelled');
          //   this.deliveryData['Cancelled'] = {
          //     items: cancelledItems,
          //     shipmentStatus: 'Cancelled',
          //     itemCount: cancelledItems.length
          //   };
          // }

          // // 2. PACKED FLOW
          // const packedItems = (packageDetails || []).flatMap(p => p.items || []);

          // // 3. TO BE DELIVERED = NOT CANCELLED + NOT PACKED
          // const toBeDeliveredItems = (orderItems || []).filter(orderItem => {
          //   const isCancelled = orderItem.cancelledQuantity > 0;
          //   const isPacked = packedItems.some(p => p.partNumber === orderItem.partNumber);
          //   return !isCancelled && !isPacked;
          // });

          // if (toBeDeliveredItems.length > 0) {
          //   this.deliveries.push('To Be Delivered');
          //   this.deliveryData['To Be Delivered'] = {
          //     items: toBeDeliveredItems,
          //     shipmentStatus: 'Confirmed',
          //     itemCount: toBeDeliveredItems.length
          //   };
          // }
          const orderItems = res['data'].orderItems || [];
          const packageDetails = res['data'].packageDetails || [];

          this.deliveries = [];
          this.deliveryData = {};

          if (res['data'].packageDetails.length > 0) {

            const packages = res['data'].packageDetails || [];
            const orderItems: any[] = res['data'].orderItems || [];

            const orderItemMap: Map<string, any> = new Map(
              orderItems.map((item: any) => [item.partNumber, item])
            );

            // Find items NOT packed (compare by partName)
          const packedItems = res['data'].packageDetails.flatMap(pkg => pkg.items);
          this.orderPackageId = res['data'].packageDetails.flatMap(pkg =>
            (pkg.items || []).map(item => item.packageId)
          );
          this.packageId = this.orderPackageId[0] || null;

          // console.log("All orderPackageIds-----", this.orderPackageId);

            res['data'].notPackedItems = orderItems.filter(orderItem =>
              !packedItems.some(packedItem => packedItem.partNumber === orderItem.partNumber)  &&
              (!orderItem.cancelledQuantity || orderItem.cancelledQuantity <= 0)
            );
          const backOrders = res['data'].backOrders.flatMap(pkg => pkg.items);
            res['data'].notBackorderItems = res['data'].notPackedItems.filter(orderItem =>
              !backOrders.some(packedItem => packedItem.partNumber === orderItem.partNumber)
            );
          
            const orderItemsMap = new Map(orderItems.map(item => [item.partNumber, item]));

            // Top-level notPackedItems
            const notPacked = Array.isArray(res['data'].notPackedItems) ? res['data'].notPackedItems : [];

            // Create a Set of partNumbers for fast match
            const notPackedPartNumbers = new Set(notPacked.map(i => i.partNumber));

            // Process each backOrder individually
            res['data'].backOrders = (res['data'].backOrders || []).map(order => {
              // Filter items that are in notPackedItems
              const filteredItems = (order.items || []).filter(item =>
                notPackedPartNumbers.has(item.partNumber)
              );

              // Match itemInfo from orderItemsMap
              const matchedItems = filteredItems
                .map(i => orderItemsMap.get(i.partNumber))
                .filter(Boolean);

              return {
                ...order,
                itemInfo: matchedItems,
              };
            });

            // console.log(res['data'].backOrders);

            const cancelledItems = (res['data'].orderItems || []).filter(
              (item: any) => item.cancelledQuantity && item.cancelledQuantity > 0
            );

            
            
            packages.forEach((pkg: any, index: number) => {
              const label = `DELIVERY ${index + 1}`;

              const enrichedItems = (pkg.items || []).map((pkgItem: any) => {
                const matchedItem = orderItemMap.get(pkgItem.partNumber);
                return matchedItem ? { ...pkgItem, ...matchedItem } : pkgItem;
              });

              this.deliveries.push(label);
              this.deliveryData[label] = {
                ...pkg,
                items: enrichedItems,
                orderConfirmTime: res['data'].orderConfirmTime,
                itemCount: enrichedItems.length
              };
            });

            // if (cancelledItems.length > 0) {
            //   if (!this.deliveries.includes('Cancelled')) {
            //     this.deliveries.push('Cancelled');
            //   }

            //   this.deliveryData['Cancelled'] = {
            //     items: cancelledItems,
            //     itemCount: cancelledItems.length,
            //     shipmentStatus: 'Cancelled'
            //   };
            // }
          //   if (this.orderDetails.notPackedItems && this.orderDetails.notPackedItems.length > 0) {
          //     // this.deliveries.push('To Be Delivered');

          //     // this.deliveryData['To Be Delivered'] = {
          //     //   items: this.orderDetails.notPackedItems,
          //     //   orderConfirmTime: res['data'].orderConfirmTime,
          //     //   itemCount: this.orderDetails.notPackedItems.length,
          //     //   shipmentStatus: "Confirmed"
          //     // };
          //     const toBeDeliveredItems = (this.orderDetails.notPackedItems || []).filter((item: any) => {
          //     const qty = item.quantity || 0;
          //     const cancelledQty = item.cancelledQuantity || 0;

          //     const effectiveQty = qty - cancelledQty;

          //     return effectiveQty > 0;
          //   });
          //   if (toBeDeliveredItems.length > 0) {
          //   this.deliveries.push('To Be Delivered');

          //   this.deliveryData['To Be Delivered'] = {
          //     items: toBeDeliveredItems,
          //     orderConfirmTime: res['data'].orderConfirmTime,
          //     itemCount: toBeDeliveredItems.length,
          //     shipmentStatus: "Confirmed"
          //   };
          // }
          //   }
          this.cdr.detectChanges();

          //   setTimeout(() => {
          //     // console.log("this.selectedDelivery----",this.deliveryData[this.selectedDelivery]);
          //     // this.currentselectedDelivery = this.deliveryData[this.selectedDelivery]['packageId'];
          //     // console.log("this.currentStatus -----",this.currentselectedDelivery);
          //     if(!this.selectedDelivery){
          //     this.selectedDelivery = this.deliveries[0];
          //     // console.log("this.selected delivery in if condition ",this.selectedDelivery);
          //     }
          //     this.setCurrentStatus(this.deliveryData[this.selectedDelivery]);
          //          const current = this.deliveryData[this.selectedDelivery];

          // if (current?.orderConfirmTime && current?.deliveryTime){
          //     // if(this.deliveryData[this.selectedDelivery].deliveryTime !=null)
          //     this.formatOrderDeliveryTime(this.deliveryData[this.selectedDelivery].orderConfirmTime, this.deliveryData[this.selectedDelivery].deliveryTime);
          //     }
          //   });
          if (!this.selectedDelivery && this.deliveries.length > 0) {
            this.selectedDelivery = this.deliveries[0];
          }

          this.setCurrentStatus(this.deliveryData[this.selectedDelivery]);

          const current = this.deliveryData[this.selectedDelivery];

          if (current?.orderConfirmTime && current?.deliveryTime) {
            this.formatOrderDeliveryTime(
              current.orderConfirmTime,
              current.deliveryTime
            );
          }
            // console.log("deliveries",this.deliveries);
          }else{

            // if (toBeDeliveredItems.length > 0) {
            //   this.deliveries.push('To Be Delivered');
            //   this.deliveryData['To Be Delivered'] = {
            //     items: toBeDeliveredItems,
            //     shipmentStatus: 'Confirmed',
            //     itemCount: toBeDeliveredItems.length
            //   };
            // }
            if (!this.selectedDelivery && this.deliveryData['Cancelled']) {
              this.selectedDelivery = 'Cancelled';
            }
            this.setCurrentStatus(res['data']);
            const current = this.deliveryData[this.selectedDelivery];

          if (current?.orderConfirmTime && current?.deliveryTime) {
        
          
            this.formatOrderDeliveryTime(
              res['data'].orderConfirmTime,
              res['data'].orderDeliveryTime
            );
          }
          }

          // ---------------- PACKED ITEMS ----------------
          const packedItems = (packageDetails || []).flatMap(p => p.items || []);

          const toBeDeliveredItems = orderItems
            .map(item => {

              const cancelledQty = item.cancelledQuantity || 0;

              // actual packed qty from packages
              const packedQty = packedItems
                .filter(p => p.partNumber === item.partNumber)
                .reduce((sum, p) => sum + (p.quantity || 0), 0);

              const remainingQty =
                (item.quantity || 0) - cancelledQty - packedQty;

              return {
                ...item,
                remainingQty
              };
            })
          .filter(item => item.remainingQty > 0);
                  if (toBeDeliveredItems.length > 0) {
                    this.deliveries.push('To Be Delivered');
                  this.deliveryData['To Be Delivered'] = {
                    items: toBeDeliveredItems,
                    shipmentStatus: 'Confirmed',
                    itemCount: toBeDeliveredItems.reduce((sum, i) => sum + i.remainingQty, 0)
                  };
          }
          // this.orderDetails.notBackorderItems = toBeDeliveredItems;
          this.orderDetails.notBackorderItems = res['data'].packageDetails.length > 0 || res['data'].backOrders.length > 0 ? toBeDeliveredItems : [];

          // ---------------- CANCELLED ----------------
          const cancelledItems = orderItems.filter(
            (item: any) => (item.cancelledQuantity || 0) > 0
          );

          if (cancelledItems.length > 0) {
            if (!this.deliveries.includes('Cancelled')) {
            this.deliveries.push('Cancelled');
          }
            this.deliveryData['Cancelled'] = {
              items: cancelledItems,
              shipmentStatus: 'Cancelled',
              itemCount: cancelledItems.length
            };
          }

          // DEFAULT SELECTED TAB
          if (!this.selectedDelivery && this.deliveries.length > 0) {

              this.selectedDelivery = this.deliveries[0];

          }

          this.invoice=res['data'].invoice;
          if (res['data'].invoice && res['data'].invoice.length > 0) {
            this.invoiceUrl = res['data'].invoice[0].invoiceUrl;
          }
          // console.log('DELIVERIES3 =>', this.deliveries);
          // console.log('DELIVERY DATA3 =>', this.deliveryData);
          // console.log('notBackorderItems:', this.orderDetails.notBackorderItems);
          // console.log('DELIVERIES3 =>', this.deliveries);
          // console.log('DELIVERY DATA3 =>', this.deliveryData);
                    this.titleTimelineDetails();
                  // this.orderDetails.grandTotal = this.orderDetails.grandTotal + (this.orderDetails.shippingCharges > 0 ? this.orderDetails.shippingCharges : 0);
                }
              );
          }

    formatOrderDeliveryTime(confirmTime: string, deliveryTime: string): void {
    try {
      const confirmDate = new Date(confirmTime?.replace(" ", "T"));
      const deliveryDate = new Date(deliveryTime?.replace(" ", "T"));
      // console.log("confirm time----",confirmDate);
      // console.log("delivery time----",deliveryDate);
      if (isNaN(confirmDate.getTime()) || isNaN(deliveryDate.getTime())) {
        // console.error('Invalid date format:', confirmTime);
        this.orderDeliveryTimeFormatted = 'Invalid time data';
        return;
      }

      const diffMs = deliveryDate.getTime() - confirmDate.getTime();
      const diffMins = Math.floor(diffMs / 60000);

      if (diffMins < 0) {
        // console.error('Delivery time is earlier than confirm time:', diffMins);
        this.orderDeliveryTimeFormatted = 'Invalid time data';
        return;
      }

      if (diffMins <= 180) {
        this.orderDeliveryTimeFormatted = `${diffMins} minutes`;
      } else {
        const hours = Math.floor(diffMins / 60);
        const minutes = diffMins % 60;
        this.orderDeliveryTimeFormatted = `${hours}H ${minutes} min`;
      }

    } catch (error) {
      // console.error('Error formatting delivery time:', error);
      this.orderDeliveryTimeFormatted = 'Invalid time data';
    }
     const fullDateTime = this.getStatusDate('orderDelivery');
      this.returnDate = fullDateTime.split(' ')[0];
      // console.log(" this.returnDate", this.returnDate)
      this.aspOrderListService.getReturnDate(this.returnDate).subscribe(
    res => {
      // console.log("resDates",res)
      this.resDateOnly=res;
      const resDateStr = res['data']; // e.g., '2025-07-04 12:11:50'

      // Convert string to Date object
      const resDate = new Date(resDateStr.replace(' ', 'T')); // ⬅️ IMPORTANT

      const today = new Date();

      // Normalize both to ignore time
      const resDateOnly = new Date(resDate.getFullYear(), resDate.getMonth(), resDate.getDate());
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      if (resDateOnly < todayOnly) {
        // console.log('❌ Expired');
      } else{
        this.dueDate=true;
      }
          });
      }
    changeTab(){
    
      this.setCurrentStatus(this.deliveryData[this.selectedDelivery]);

      const current = this.deliveryData[this.selectedDelivery];

      if (current?.orderConfirmTime && current?.deliveryTime) {
        this.formatOrderDeliveryTime(current.orderConfirmTime, current.deliveryTime);
      }
      //  if(this.deliveryData[this.selectedDelivery].orderConfirmTime != null && this.deliveryData[this.selectedDelivery].deliveryTime)
      //   this.formatOrderDeliveryTime(this.deliveryData[this.selectedDelivery].orderConfirmTime, this.deliveryData[this.selectedDelivery].deliveryTime);
      this.titleTimelineDetails();
      this.scrollSelectedIntoView();
      // this.getOrderDetails(this.orderKey);
      


    }

    setCurrentStatus(data: any) {
      const statusOrder = ['Confirmed', 'Packed', 'On The Way', 'Delivered'];
      if(data.orderConfirmTime){
        var confirmed='Confirmed';
      }
      if(data.packageDate){
        var packed='Packed';
      }
      if(data.shipmentDate){
        var onTheWay='On The Way';
      }
      if(data.shipmentStatus=="delivered"){
        var delivered='Delivered';
      }
      const statuses = [confirmed, packed, onTheWay, delivered];
      const dates = [data.orderConfirmTime, data.packedTime, data.shippedTime, data.deliveryTime];

      this.currentStatusIndex = -1;
      this.statusDates = {};
      for (let i = 0; i < statuses.length; i++) {
        if (statuses[i] === statusOrder[i]) {
          this.currentStatusIndex = i;
          this.statusDates[statusOrder[i]] = dates[i];
        }
        if (dates[i]) {
          this.statusDates[statusOrder[i]] = dates[i];
        }
      }
    }

    getStatusName(status: string) {
      switch (status) {
        case 'orderConfirm':
          return 'Confirmed';
        case 'orderPacked':
          return 'Packed';
        case 'orderOnTheWay':
          return 'On The Way';
        case 'orderDelivery':
          return 'Delivered';
        default:
          return '';
      }
    }
    getStatusDate(status: string) {
      return this.statusDates[this.getStatusName(status)] || 'Not Available';
    }

    isActive(index: number) {
      return index <= this.currentStatusIndex;
    }

    navigateToCart(): void {
      if (this.orderDetails && this.orderDetails.orderItems) {
        // Assuming you have a CartService that handles the cart data
        this.orderDetails.orderItems;
        this.router.navigate(['/cart']); 
      } else {
        console.error('Order details or order items are not available');
      }
    }

    getTotalPrice(): number {
      let totalPrice = 0;
      for (let item of this.orderDetails.orderItems) {
        totalPrice += item.price * item.quantity;
      }
      return totalPrice;
    }
    getStatusImage(status: string): string {
      return this.images[this.getStatusName(status)] || '';
    }

  openInvoiceUrl(invoiceUrl): void {
    if (invoiceUrl) {
      window.open(invoiceUrl, '_blank');
    } else {
      this.toastr.error('Invoice URL is not available');
    }
  }
  openTracking(trackingUrl): void {
    
    if (trackingUrl !=null) {
      window.open(trackingUrl, '_blank');
    } else {
      console.error('Invoice URL is not available');
    }
  }

  getReorder(key: string) { 
    localStorage.removeItem('addedCart');
    this.aspOrderListService.getReorder(key).subscribe(
      res => {
        if (res['code'] === 200) {
          let reorder = {};
          this.addedCart = []
      
          res['data'].forEach(item => {
              item.cart_qty = 1;
              item.spareStocks = {
                "partNumber": item.partNumber,
                "discountAmount": item.discount,
                "discountType": item.discountType,
                "mrp": item.mrp,
                "sellingPrice": item.sellingPrice,
                "quantity": item.count
              };
              let make = this.orderDetails.make;
              let model =  this.orderDetails.model 
              let registrationNumber =  this.orderDetails.registrationNumber
              let variant =  this.orderDetails.variant  
              let mfgYear =  this.orderDetails.mfgYear       
              let fuelType =  this.orderDetails.fuelType       
              let rowKey =  this.orderDetails.rowKey 
              let variantKey =  this.orderDetails.variantKey     
              item = {
                ...item.spareStocks, 
                ...item, 
                selectedMake: make,
                selectedModel: model,
                registrationNumber: registrationNumber,
                variant: variant,
                selectedYear: mfgYear,
                selectedFuel: fuelType, 
                rowKey: rowKey, 
                variantKey: variantKey      
              };
              reorder[item.key] = item;
              this.addedCart.push(reorder);
          });
      
          localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
          this.router.navigate(['cart']);
      }
    
      }
    );
    }

    shareOnWhatsApp() {
      const garageName=this.spareSelectedGarageName
      const orderNumber = this.orderNumber;
      const deepLink = `http://www.autoversemobility.in/order/${this.orderKey}`;
      const message = `🚗  Track Your Order Now! 🚗 \n\nHey ${garageName},\n\nTrack your order (Order No: ${orderNumber}) in the Autoverse Spares App.\n\n📱  Click here to track: ${deepLink}`;
    
      const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
      
    
    }
    
    shareOnWhatsAppmob() {
      const garageName = this.spareSelectedGarageName;
      const orderNumber = this.orderNumber;
      const deepLink = `http://www.autoversemobility.in/order/${this.orderKey}`;
      const message = `🚗 Track Your Order Now! 🚗 \n\nHey ${garageName},\n\nTrack your order (Order No: ${orderNumber}) in the Autoverse Spares App.\n\n📱 Click here to track: ${deepLink}`;
      
      // Use wa.me URL scheme for mobile compatibility
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    }

    openMenu() {
      this.isBottomSheetOpen = true;
    }
    closeMenu(): void {
      this.isBottomSheetOpen = false;
    }
    openDownload() {
      this.isDownloadBottomSheet = !this.isDownloadBottomSheet;
    }
  getBalancePayable(): number {
    const o = this.orderDetails || {};

    const grandTotal = parseFloat((o.grandTotal || 0).toFixed(2));
    const shippingCharges = parseFloat((o.shippingCharges || 0).toFixed(2));
    const walletAmount = parseFloat((o.walletAmount || 0).toFixed(2));
    const prepaidAmount = parseFloat((o.prepaidAmount || 0).toFixed(2));

    const balance = grandTotal + shippingCharges - walletAmount - prepaidAmount;

    return parseFloat(balance.toFixed(2)); // Final rounding
  }

  ngAfterViewChecked() {
      if (!this.initialCheckDone && this.tabScrollContainer) {
        this.initialCheckDone = true;
        this.updateScrollButtons();
      }
    }


  updateScrollButtons() {
      const container = this.tabScrollContainer.nativeElement;
      const scrollLeft = container.scrollLeft;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      this.showRight = scrollLeft < maxScrollLeft || scrollLeft > 0;

      this.cdRef.detectChanges();
    }

    scrollTabs(direction: 'left' | 'right') {
      const container = this.tabScrollContainer.nativeElement;
      const scrollAmount = 150;

      if (direction === 'left') {
        container.scrollLeft -= scrollAmount;
      } else {
        container.scrollLeft += scrollAmount;
      }

      setTimeout(() => this.updateScrollButtons(), 300);
    }
  // Optional: update when user scrolls manually
  onTabScroll() {
    this.updateScrollButtons();
  }
  getImage(status: string): string {
    if (!status) return '';

    const properCaseStatus = status
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());

    return this.images[properCaseStatus] || 'assets/images/default.png'; // fallback if not found
  }
  scrollIntoView(element: HTMLElement): void {
    element.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }
  scrollSelectedIntoView(): void {
    const index = this.deliveries.indexOf(this.selectedDelivery);
    const elementRef = this.deliveryToggles.toArray()[index]; // ✅ Fix here

    if (elementRef?.nativeElement) {
      elementRef.nativeElement.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => this.scrollSelectedIntoView(), 0);

  }
  formatExpectedDeliveryTime(edt: string | Date): string {
    if (!edt) return 'Invalid date';

    const inputDate = new Date(edt);
    if (isNaN(inputDate.getTime())) return 'Invalid date';

    // Convert to IST manually (add 5 hours 30 minutes)
    // const istOffsetInMs = 330 * 60 * 1000; // 330 minutes
    // const deliveryDate = new Date(inputDate.getTime() + istOffsetInMs);
    const deliveryDate = new Date(inputDate.getTime());

    const now = new Date();
    const isToday = now.toDateString() === deliveryDate.toDateString();

    const isTomorrow = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    ).toDateString() === deliveryDate.toDateString();

    const time = deliveryDate.toLocaleTimeString('en-IN', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    if (isToday) {
      return `Today, ${time}`;
    } else if (isTomorrow) {
      return `Tomorrow, ${time}`;
    } else {
      return deliveryDate.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    }
  }

  formatGoOrderEdt(edt: any): string {
    if (!edt) return 'Invalid date';

    const originalDate = new Date(edt);
    if (isNaN(originalDate.getTime())) return 'Invalid date';

    // Convert UTC to IST by adding 5 hours 30 minutes (330 minutes)
    const istOffsetInMs = 330 * 60 * 1000;
    const istDate = new Date(originalDate.getTime() + istOffsetInMs);

    // Add 45 minutes for delivery time
    const updatedDate = new Date(istDate.getTime() + 45 * 60 * 1000);

    const now = new Date(); // Local time (assumed IST already)
    const isToday = now.toDateString() === updatedDate.toDateString();
    const isTomorrow = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    ).toDateString() === updatedDate.toDateString();

    const time = updatedDate.toLocaleTimeString('en-IN', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    if (isToday) {
      return `Today, ${time}`;
    } else if (isTomorrow) {
      return `Tomorrow, ${time}`;
    } else {
      return updatedDate.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    }
  }


  isReturned(partNumber: string): boolean {
    return this.orderDetails.salesReturn.some(item => item.partNumber === partNumber);
  }
  returnItem(item: any){
    if(this.returnWindowType!=='Late Return'){
    this.returnWindowType = '24 Hours';
    localStorage.setItem("returnWindowType",this.returnWindowType);
    }
    //  console.log("this.returnWindowType------------",this.returnWindowType)
    // console.log("item============================",item)
      this.closeLateReturnSheet();

      // console.log("Force dismissing bottom sheet");
    this.bottomSheet.dismiss();
    this.closeSidebar(false);
      this.getStatusDate('orderDelivery');
      // console.log("this.getStatusDate('orderDelivery');",this.getStatusDate('orderDelivery'))
      const factory = this.resolver.resolveComponentFactory(AspReturnItemsComponent);
      const componentRef = this.container.createComponent(factory);

      // Access the instance and call the method
      const componentBInstance = componentRef.instance as AspReturnItemsComponent;
      componentBInstance.itemResponse(item,this.resDateOnly,this.orderKey);
      componentBInstance.openPopup();

      
  }
  trackReturn(targetPartNumber){
    const matchedItem =  this.orderDetails.salesReturn.find(item => item.partNumber === targetPartNumber);

          this.aspLoadingService.show();
    // console.log('salesReturnId:', matchedItem.salesReturnId);
    // console.log('salesReturnItemId:', matchedItem.salesReturnItemId);
    this.aspOrderListService.retuenStatus(matchedItem.salesReturnId,matchedItem.salesReturnItemId).subscribe(
        res => {
          this.aspLoadingService.hide();
          if(res['code']==200){
            this.trackItem=true;
            // console.log("res",res)
            this.returnData = res['data'];
            this.statusInfo=res['data'].statusInfo
          }else{
          this.toastr.error(res['message'])
        }
        })  
    
  }
  getFormattedDate(dateStr: string): string {
    const date = new Date(dateStr);
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: '2-digit',
    };
    const formatted = new Intl.DateTimeFormat('en-US', options).format(date);
    return formatted.replace(',', ''); // e.g., "Saturday July 12"
  }
  closeTrackItem(){
  this.trackItem=false;
  }

  openLateReturnSheet(item) {
    this.item = item
    // console.log("pop up opened")
    this.returnWindowType = 'Late Return';
    localStorage.setItem("returnWindowType",this.returnWindowType);
    //  console.log("this.returnWindowType------------",this.returnWindowType)
    this.showLateReturnSheet = true;
  }

  closeLateReturnSheet() {
    this.showLateReturnSheet = false;
  }

  calculateHoursFromNow(dateStr: string | Date): number {
    if (!dateStr) return 0;

    let dateObj: Date;

    if (typeof dateStr === 'string') {
      // Convert "2025-08-19 13:01:31" → "2025-08-19T13:01:31Z"
      const isoString = dateStr.replace(' ', 'T') + 'Z';
      dateObj = new Date(isoString);
    } else {
      dateObj = new Date(dateStr);
    }

    const givenTime = dateObj.getTime();
    if (isNaN(givenTime)) return 0;

    const now = Date.now();
    return (now - givenTime) / (1000 * 60 * 60);
  }

  returnItemForAll() {
    this.showLateReturnSheet = false;
    // console.log("late return sheet opened");
      this.returnItem(this.item); 
    // console.log("items of items of items of items of items",this.item);

    setTimeout(() => {
      this.cdr.detectChanges();
    });
    this.closeLateReturnSheet();
    
  }


  downloadFile() {
    const url = this.returnData.salesReturnInfo.creditNoteUrl;
  const a = document.createElement('a');
    a.href = url;
    a.target = '_blank'; // Open in new window/tab
    a.click();
  }

  // titleTimelineDetails() {
  //   const orderKey = this.orderKey;
  //   const packageIds = this.orderPackageId;
  //   console.log("All orderPackageIds in timeline-----", this.orderPackageId);
  //   const userKey = localStorage.getItem('spareUserKey');
  //   console.log("userKey ----", userKey);

  //   this.aspOrderListService.timeLine(userKey, orderKey).subscribe(
  //     (res: any) => {
  //       if (res.code === 200) {
  //         const data = res.data;
  //         this.timelineData = data.status || [];
  //         this.packageTimelineData = [];
  //         if (data.packagesStatus && Array.isArray(data.packagesStatus)) {
  //           data.packagesStatus.forEach(pkg => {
  //             Object.keys(pkg).forEach(key => {
  //               const events = pkg[key] || [];

  //               if (Array.isArray(events)) {
  //                 events.sort(
  //                   (a, b) =>
  //                     new Date(b.createdAt.replace(" ", "T")).getTime() -
  //                     new Date(a.createdAt.replace(" ", "T")).getTime()
  //                 );
  //                 this.packageTimelineData.push({
  //                   packageId: key,
  //                   events: events
  //                 });
  //                 this.timelineData.push(...events);
  //               }
  //             });
  //           });
  //         }
  //         if (Array.isArray(this.timelineData)) {
  //           this.timelineData.sort((a, b) => {
  //             const dateA = new Date(a.createdAt.replace(" ", "T")).getTime();
  //             const dateB = new Date(b.createdAt.replace(" ", "T")).getTime();
  //             return dateB - dateA; 
  //           });
  //         }
  //         console.log("Final Timeline (merged + sorted) ----", this.timelineData);
  //         if (this.orderDetails && this.orderDetails.packageDetails) {
  //           this.orderDetails.packageDetails = this.orderDetails.packageDetails.map(pkg => {
  //             const enrichedItems = (pkg.items || []).map(item => {
  //               const matchedTimeline = this.packageTimelineData.find(
  //                 t => t.packageId === item.packageId
  //               );
  //               return {
  //                 ...item,
  //                 timeline: matchedTimeline ? matchedTimeline.events : []
  //               };
  //             });

  //             const pkgTimeline = enrichedItems.flatMap(i => i.timeline);

  //             pkgTimeline.sort(
  //               (a, b) =>
  //                 new Date(b.createdAt.replace(" ", "T")).getTime() -
  //                 new Date(a.createdAt.replace(" ", "T")).getTime()
  //             );

  //             return {
  //               ...pkg,
  //               items: enrichedItems,
  //               timeline: pkgTimeline
  //             };
  //           });

  //           console.log(
  //             "OrderDetails with timeline merged (sorted) ----",
  //             this.orderDetails.packageDetails
  //           );
  //         } else {
  //           console.warn("OrderDetails not loaded yet ----", this.orderDetails);
  //         }
  //       }
  //     },
  //     error => {
  //       console.error("Timeline API Error----", error);
  //     }
  //   );
  // }



  // steps = [
  //     {
  //       time: 'Jun 21, 2:00 PM',
  //       title: 'On the move!',
  //       description: 'Your parts are on the way to your garage.',
  //     },
  //     {
  //       time: 'Jun 21, 1:15 PM',
  //       title: 'Final checks underway',
  //       description: 'The delivery partner is at the warehouse for final checks.',
  //     },
  //     {
  //       time: 'Jun 21, 12:30 PM',
  //       title: 'Delivery partner assigned',
  //       description: 'Our runner is assigned and will pick up your parts shortly.',
  //     },
  //     {
  //       time: 'Jun 21, 11:45 AM',
  //       title: 'Shipment arranged',
  //       description: 'Dispatch scheduled. Shipment is ready.',
  //     },
  //     {
  //       time: 'Jun 21, 10:30 AM',
  //       title: 'Packed',
  //       description: 'Your parts have been packed and are ready for dispatch.',
  //     },
  //     {
  //       time: 'Jun 21, 9:15 AM',
  //       title: 'Order confirmed',
  //       description: 'Your order is confirmed and parts are being arranged.',
  //     },
  //     {
  //       time: 'Jun 21, 9:05 AM',
  //       title: 'Order received',
  //       description: 'We’ve received your order request.',
  //     },
  //   ];
  // titleTimelineDetails() {
  //   const orderKey = this.orderKey;
  //   const packageIds = this.orderPackageId || [];
  //   const selectedDelivery = this.selectedDelivery;
  //   console.log("All orderPackageIds in timeline-----", packageIds);
  //   console.log("selectedDelivery ---", selectedDelivery);
  //   let selectedIndex = this.deliveries.indexOf(selectedDelivery);
  //   if (selectedIndex === -1 && typeof selectedDelivery === 'string') {
  //     const m = selectedDelivery.match(/(\d+)$/);
  //     if (m) {
  //       selectedIndex = parseInt(m[1], 10) - 1;
  //     }
  //   }
  //   const selectedPackageId =
  //     selectedIndex >= 0 && selectedIndex < packageIds.length
  //       ? packageIds[selectedIndex]
  //       : null;

  //   console.log("Selected packageId ----", selectedPackageId);

  //   const userKey = localStorage.getItem('spareUserKey');
  //   console.log("userKey ----", userKey);

  //   this.aspOrderListService.timeLine(userKey, orderKey).subscribe(
  //     (res: any) => {
  //       if (res.code === 200) {
  //         const data = res.data;
  //         this.timelineData = data.status || []; // base order-level events
  //         this.packageTimelineData = [];

  //         if (data.packagesStatus && Array.isArray(data.packagesStatus)) {
  //           data.packagesStatus.forEach(pkg => {
  //             Object.keys(pkg).forEach(key => {
  //               const events = pkg[key] || [];

  //               if (Array.isArray(events)) {
  //                 events.sort(
  //                   (a, b) =>
  //                     new Date(b.createdAt.replace(' ', 'T')).getTime() -
  //                     new Date(a.createdAt.replace(' ', 'T')).getTime()
  //                 );
  //                 this.packageTimelineData.push({
  //                   packageId: key,
  //                   events: events,
  //                 });
  //                 if (selectedPackageId && key === selectedPackageId) {
  //                   this.timelineData.push(...events);
  //                 }
  //               }
  //             });
  //           });
  //         }
  //         if (Array.isArray(this.timelineData)) {
  //           this.timelineData.sort((a, b) => {
  //             const dateA = new Date(a.createdAt.replace(' ', 'T')).getTime();
  //             const dateB = new Date(b.createdAt.replace(' ', 'T')).getTime();
  //             return dateB - dateA;
  //           });
  //         }
  //         console.log(
  //           'Final Timeline (filtered + merged + sorted) ----',
  //           this.timelineData
  //         );
  //         if (this.orderDetails && this.orderDetails.packageDetails) {
  //           this.orderDetails.packageDetails = this.orderDetails.packageDetails.map(pkg => {
  //             const enrichedItems = (pkg.items || []).map(item => {
  //               const matchedTimeline = this.packageTimelineData.find(
  //                 t => t.packageId === item.packageId
  //               );
  //               return {
  //                 ...item,
  //                 timeline: matchedTimeline ? matchedTimeline.events : [],
  //               };
  //             });

  //             const pkgTimeline = enrichedItems.flatMap(i => i.timeline);

  //             pkgTimeline.sort(
  //               (a, b) =>
  //                 new Date(b.createdAt.replace(' ', 'T')).getTime() -
  //                 new Date(a.createdAt.replace(' ', 'T')).getTime()
  //             );

  //             return {
  //               ...pkg,
  //               items: enrichedItems,
  //               timeline: pkgTimeline,
  //             };
  //           });

  //           console.log(
  //             'OrderDetails with timeline merged (sorted) ----',
  //             this.orderDetails.packageDetails
  //           );
  //         } else {
  //           console.warn('OrderDetails not loaded yet ----', this.orderDetails);
  //         }
  //       }
  //     },
  //     error => {
  //       console.error('Timeline API Error----', error);
  //     }
  //   );
  // }

//   titleTimelineDetails() { 
//     const orderKey = this.orderKey;
//     const packageIds = this.orderPackageId || [];
//     const currentDelivery = this.selectedDelivery;
//     // console.log("this.selected delivery in if condition ----", currentDelivery);
//     // console.log("All orderPackageIds in timeline -----", this.orderPackageId);
//     const userKey = localStorage.getItem('spareUserKey');
//     // console.log("userKey ----", userKey);

//     // ✅ Extract the index number from "DELIVERY 1", "DELIVERY 2", etc.
//     let selectedIndex = 0;
//     if (currentDelivery && currentDelivery.toUpperCase().startsWith("DELIVERY")) {
//       const numPart = currentDelivery.replace(/\D/g, "");
//       selectedIndex = parseInt(numPart, 10) - 1; 
//       // if(selectedIndex == -1)
//       // {
//       //   selectedIndex =0;
//       // }
//     }

//     // console.log("Selected Delivery Index ----", selectedIndex);

//     // ✅ Get corresponding packageId based on index
//     const selectedPackageId = packageIds[selectedIndex];
//     // console.log("Selected Package ID ----", selectedPackageId);

//     this.aspOrderListService.timeLine(userKey, orderKey).subscribe(
//       (res: any) => {
//         if (res.code === 200) {
//           const data = res.data;
//           this.timelineData = [];
//           this.packageTimelineData = [];

//           // --- Helper: convert GMT to IST ---
//           const convertGMTtoIST = (gmtDateStr: string) => {
//             const date = new Date(gmtDateStr.replace(" ", "T") + "Z");
//             //  + 330 * 60 * 1000
//             // const istDate = new Date(date.getTime()); // +5:30 offset
//             const istDate = new Date(date.getTime() +  60 * 1000);
//             return istDate.toLocaleString("en-US", {
//               month: "short",
//               day: "numeric",
//               hour: "numeric",
//               minute: "2-digit",
//               hour12: true
//             });
//           };

//           // --- Global order-level statuses ---
//           const globalStatus = Array.isArray(data.status)
//             ? data.status.map(item => ({
//                 ...item,
//                 createdAt: convertGMTtoIST(item.createdAt),
//                 packageId: null
//               }))
//             : [];

//           // this.timelineData.push(...globalStatus);

//           // --- Process package-wise timelines ---
//           // if (data.packagesStatus && Array.isArray(data.packagesStatus)) {
//           //   data.packagesStatus.forEach(pkg => {
//           //     Object.keys(pkg).forEach(key => {
//           //       const events = pkg[key] || [];
//           //       // console.log("events of timeline entry ----", events);
//           //       if (Array.isArray(events)) {
//           //         const filteredEvents = events.map(event => ({
//           //           ...event,
//           //           createdAt: convertGMTtoIST(event.createdAt),
//           //           packageId: key
//           //         }));

//           //         // filteredEvents.sort(
//           //         //   (a, b) =>
//           //         //     new Date(b.createdAt.replace(" ", "T")).getTime() -
//           //         //     new Date(a.createdAt.replace(" ", "T")).getTime()
//           //         // );
//           //         // filteredEvents.sort((a, b) => a.sequence - b.sequence);

//           //         // console.log("filteredEvents -----", filteredEvents);

//           //         // ✅ Only push if this packageId matches the currently selected one
//           //         if (key === selectedPackageId) {
//           //           this.packageTimelineData.push({
//           //             packageId: key,
//           //             events: filteredEvents
//           //           });
//           //           this.timelineData.push(...filteredEvents);
//           //         }
//           //       }
//           //     });
//           //   });
//           // }

//           // --- Process package-wise timelines ---
// if (
//   !selectedPackageId ||
//   !data.packagesStatus ||
//   !Array.isArray(data.packagesStatus) ||
//   data.packagesStatus.length === 0
// ) {
//   this.timelineData = [...globalStatus];
//   return;
// }

// let packageMatched = false;

// if (data.packagesStatus && Array.isArray(data.packagesStatus)) {
//   data.packagesStatus.forEach(pkg => {
//     Object.keys(pkg).forEach(key => {
//       const events = pkg[key] || [];

//       if (Array.isArray(events)) {

//         const filteredEvents = events.map(event => ({
//           ...event,
//           createdAt: convertGMTtoIST(event.createdAt),
//           packageId: key
//         }));

//         // ✅ Push only selected package timeline
//         if (key === selectedPackageId) {

//           packageMatched = true;

//           this.packageTimelineData.push({
//             packageId: key,
//             events: filteredEvents
//           });

//           this.timelineData.push(...filteredEvents);
//         }
//       }
//     });
//   });
// }

// // ✅ Fallback to common status if package not found
// if (!packageMatched) {
//   this.timelineData.push(...globalStatus);
// }

//           // --- Sort merged timeline events (latest first) ---
//           // this.timelineData.sort(
//           //   (a, b) =>
//           //     new Date(b.createdAt.replace(" ", "T")).getTime() -
//           //     new Date(a.createdAt.replace(" ", "T")).getTime()
//           // );
//           // this.timelineData.sort((a, b) => a.sequence - b.sequence);

//           // console.log("Filtered Final Timeline ----", this.timelineData);

//           // --- Merge timeline back into orderDetails.packageDetails ---
//           if (this.orderDetails && this.orderDetails.packageDetails) {
//             this.orderDetails.packageDetails = this.orderDetails.packageDetails.map(pkg => {
//               const pkgTimeline = this.packageTimelineData.find(
//                 t => t.packageId === pkg.packageId
//               );

//               const enrichedItems = (pkg.items || []).map(item => ({
//                 ...item,
//                 timeline: pkgTimeline ? pkgTimeline.events : []
//               }));

//               const combinedTimeline = pkgTimeline ? pkgTimeline.events : [];

//               return {
//                 ...pkg,
//                 items: enrichedItems,
//                 timeline: combinedTimeline
//               };
//             });

//             // console.log( "OrderDetails with filtered timeline merged ----",  this.orderDetails.packageDetails );
//           } else {
//             console.warn("OrderDetails not loaded yet ----", this.orderDetails);
//           }
//         }
//       },
//       error => {
//         console.error("Timeline API Error ----", error);
//       }
//     );
//   }

titleTimelineDetails() { 
  const orderKey = this.orderKey;
  const packageIds = this.orderPackageId || [];
  const currentDelivery = this.selectedDelivery;

  const userKey = localStorage.getItem('spareUserKey');

  // ✅ Extract the index number from "DELIVERY 1", "DELIVERY 2", etc.
  let selectedIndex = -1;

  if (
    currentDelivery &&
    currentDelivery.toUpperCase().startsWith("DELIVERY")
  ) {
    const numPart = currentDelivery.replace(/\D/g, "");
    selectedIndex = parseInt(numPart, 10) - 1;
  }

  // ✅ Get corresponding packageId safely
  const selectedPackageId =
    selectedIndex >= 0 ? packageIds[selectedIndex] : null;

  this.aspOrderListService.timeLine(userKey, orderKey).subscribe(
    (res: any) => {
      if (res.code === 200) {
        const data = res.data;

        this.timelineData = [];
        this.packageTimelineData = [];

        // --- Helper: convert GMT to IST ---
        const convertGMTtoIST = (gmtDateStr: string) => {
          const date = new Date(gmtDateStr.replace(" ", "T") + "Z");

          const istDate = new Date(date.getTime() + 60 * 1000);

          return istDate.toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true
          });
        };

        // --- Global order-level statuses ---
        const globalStatus = Array.isArray(data.status)
          ? data.status.map(item => ({
              ...item,
              createdAt: convertGMTtoIST(item.createdAt),
              packageId: null
            }))
          : [];

        // ✅ If no package id available
        if (
          !selectedPackageId ||
          !data.packagesStatus ||
          !Array.isArray(data.packagesStatus) ||
          data.packagesStatus.length === 0
        ) {

          // ✅ Clear old package timelines
          this.packageTimelineData = [];

          // ✅ Show common timeline only
          this.timelineData = [...globalStatus];

          // ✅ Clear merged timelines
          if (this.orderDetails?.packageDetails) {
            this.orderDetails.packageDetails =
              this.orderDetails.packageDetails.map(pkg => ({
                ...pkg,
                timeline: [],
                items: (pkg.items || []).map(item => ({
                  ...item,
                  timeline: []
                }))
              }));
          }

          return;
        }

        let packageMatched = false;

        // --- Process package-wise timelines ---
        if (data.packagesStatus && Array.isArray(data.packagesStatus)) {

          data.packagesStatus.forEach(pkg => {

            Object.keys(pkg).forEach(key => {

              const events = pkg[key] || [];

              if (Array.isArray(events)) {

                const filteredEvents = events.map(event => ({
                  ...event,
                  createdAt: convertGMTtoIST(event.createdAt),
                  packageId: key
                }));

                // ✅ Push only selected package timeline
                if (key === selectedPackageId) {

                  packageMatched = true;

                  this.packageTimelineData.push({
                    packageId: key,
                    events: filteredEvents
                  });

                  this.timelineData.push(...filteredEvents);
                }
              }
            });
          });
        }

        // ✅ Fallback to global status if package not found
        if (!packageMatched) {
          this.timelineData = [...globalStatus];
        }

        // --- Merge timeline back into packageDetails ---
        if (this.orderDetails && this.orderDetails.packageDetails) {

          this.orderDetails.packageDetails =
            this.orderDetails.packageDetails.map(pkg => {

              const pkgTimeline = this.packageTimelineData.find(
                t => t.packageId === pkg.packageId
              );

              const enrichedItems = (pkg.items || []).map(item => ({
                ...item,
                timeline: pkgTimeline ? pkgTimeline.events : []
              }));

              const combinedTimeline =
                pkgTimeline ? pkgTimeline.events : [];

              return {
                ...pkg,
                items: enrichedItems,
                timeline: combinedTimeline
              };
            });

        } else {
          console.warn(
            "OrderDetails not loaded yet ----",
            this.orderDetails
          );
        }
      }
    },
    error => {
      console.error("Timeline API Error ----", error);
    }
  );
}

  openRegisterSheet() {
    this.showRegisterSheet = true;
  }

  closeRegisterSheet() {
    this.showRegisterSheet = false;
  }
  onRegisterParts() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }
    const garageKey = localStorage.getItem("garageKey");

    const requestBody = {
      garageKey: garageKey,
      odometerKm: this.registerForm.value.odometer,
      orderKey: this.orderKey,
      orderNumber: this.orderNumber,
      // registrationNumber: this.registerForm.value.regno,
      registrationNumber: 
      this.registerForm.get('regno')?.enabled 
        ? this.registerForm.value.regno 
        : this.orderDetails.registrationNumber,
      userMobile: this.registerForm.value.mobile,
      userName: this.registerForm.value.name,
       packageId: this.packageId
    };

    this.aspOrderListService.createRegisterPart(requestBody).subscribe(
      (response: any) => {
        // console.log("API SUCCESS:", response);

        if (response?.code === 200) {
          const data = response.data;

          // ⭐ JUST ADD THIS (your IST conversion method)
          data.createdAt = this.formatIST(data.createdAt);


          this.registeredData = data;

          // show popup
          this.closeRegisterSheet();
          this.showRegisterSheet = false;
          this.showSuccessPopup = true;
          this.bottomSheet.dismiss();
          this.closeSidebar(false);
          this.isBottomSheetOpen = false;
        }
      },
      (error) => {
        console.error("API ERROR:", error);
      }
    );
  }
  closeSuccessPopup(){
    this.showSuccessPopup = false;
  }
  formatIST(gmtTime: string) {
    if (!gmtTime) return '';

    // Convert "2025-11-25 11:59:33" → "2025-11-25T11:59:33"
    let isoString = gmtTime.replace(' ', 'T');

    // Directly convert to India format WITHOUT adding 330 minutes again
    return new Date(isoString).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }
  goToWarrantyList() {
    this.router.navigate(['/warranty-list']);
  }
  checkBrandButton(data: any): void {
    // console.log("data", data)
  this.showBrandButton =
    data?.packageDetails?.some((pkg: any) =>
      pkg?.items?.some((item: any) =>
        item?.brandName && item.brandName.trim() !== ''
      )
    ) ?? true;
    // console.log(" this.showBrandButton ",  this.showBrandButton )
}
// ------------------------- WHEN FULL ITEMS GOT CANCELLED-----------------------
  get isOrderCancelled(): boolean {
    return (
      String(this.orderDetails?.orderStatus) === '0' &&
      String(this.orderDeliveredStatus).toLowerCase() === 'cancelled'
    );
  }
  // -------------------------------WHEN PARTIAL ITEMS GOT CANCELLED---------------------
get isPartialCancelled(): boolean {
  const currentItems =
    this.deliveryData?.[this.selectedDelivery]?.items || [];

  return currentItems.some(item =>
    (item.cancelledQuantity || 0) > 0
  );
}
  
  hasCancelledItems(): boolean {
    return this.orderDetails?.orderItems?.some(
      (item: any) => item.cancelledQuantity > 0
    );
  }
  getCancelledItems() {
    return this.orderDetails?.orderItems?.filter(
      (item: any) => item.cancelledQuantity > 0
    ) || [];
  }
  viewOrders(ishide: boolean){
    this.router.navigate(['/order-list']); 
    this.isVisible = ishide;
  }
  goToHome(){
    this.router.navigate(['/home']); 
    }
  // ==========================order cancel code====================
  canCancelOrder(): boolean {
    const status = this.orderDetails?.orderCurrentStatus;

    return !['Packed', 'On The Way', 'Delivered'].includes(status);
  }

  getCancelOrderMessage(): string {
    const status = this.orderDetails?.orderCurrentStatus;

    switch (status) {
      case 'Packed':
        return 'This order cannot be cancelled because one or more items have already been packed.';

      case 'On The Way':
        return 'This order cannot be cancelled because one or more items are already on the way.';

      case 'Delivered':
        return 'This order cannot be cancelled because the order has already been delivered.';

      default:
      return '';
    }
  }
  // cancelEntireOrder() { alert('cancelEntireOrder hit');


  //   const payload = {
  //     garageKey: localStorage.getItem('garageKey'),
  //     orderKey: this.orderDetails?.orderKey,
  //     orderCancel: true,
  //     cancelItems: []
  //   };

  //    console.log('orderDetails', this.orderDetails);
  //   console.log('rowKey', this.orderDetails?.rowKey);
  //   console.log('Cancel Order Payload', payload);

  //   this.aspOrderListService.cancelOrder(payload)
  //     .subscribe({
  //       next: (res: any) => {
  //          console.log('SUCCESS RESPONSE', res);
  //         this.cancelledOrderId = this.orderDetails?.orderNumber;

  //         this.showOrderCancelPopup = false;
  //         this.showOrderCancelSuccessPopup = true;

  //         this.toastr.success('Order cancelled successfully');

  //         this.getOrderDetails(this.orderKey);
  //       },
  //       error: (err) => {
  //         console.error(err);
  //          console.log('FULL ERROR', err);
  //       console.log('ERROR BODY', err?.error);
  //         this.toastr.error('Failed to cancel order');
  //       }
  //     });
  // }
  cancelEntireOrder() {

    const payload = {
      garageKey: localStorage.getItem('garageKey'),
      orderKey: this.orderDetails?.orderKey,
      orderCancel: true,
      cancelItems: []
    };

    console.log('Cancel Order Payload', payload);
    this.aspLoadingService.show();

    this.aspOrderListService.cancelOrder(payload)
      .subscribe({
        next: (res: any) => {
           this.aspLoadingService.hide(); 

          console.log('Cancel Order Response', res);

          if (res.code === 200) {

            this.cancelledOrderId = this.orderDetails?.orderNumber;

            this.showOrderCancelPopup = false;
            this.showOrderCancelSuccessPopup = true;

            this.toastr.success('Order cancelled successfully');

            this.getOrderDetails(this.orderKey);

          } else {

            this.toastr.error(
              res?.data?.description ||
              res?.message ||
              'Failed to cancel order'
            );

          }

        },
        error: (err) => {
          this.aspLoadingService.hide();
          console.error(err);
          this.toastr.error('Failed to cancel order');
        }
      });
  }
  closeOrderCancelSuccessPopup() {
    this.showOrderCancelSuccessPopup = false;
    window.location.reload();
  }
  openCancelOrderPopup() {
  this.showOrderCancelPopup = true;
  }

  closeOrderCancelPopup() {
    this.showOrderCancelPopup = false;
  }

  confirmCancelOrder(ishide: boolean ) {
    this.isBottomSheetOpen = false;
    this.isVisible = ishide;
    this.showOrderCancelPopup = false;
    this.cancelEntireOrder();
  }
  canShowCancelOrder(): boolean {
    return !['Packed', 'On The Way', 'Delivered']
      .includes(this.orderDetails?.orderCurrentStatus);
  }

  canShowCancelItem(item: any): boolean {

    const status =
      item?.shippingStatus?.toLowerCase() ||
      item?.orderStatus?.toLowerCase() ||
      this.orderDetails?.orderCurrentStatus?.toLowerCase();

    return ['created', 'confirmed'].includes(status);
  }

  canShowLocked(item: any): boolean {
    const shipmentStatus =
    this.deliveryData?.[this.selectedDelivery]?.shipmentStatus?.toLowerCase();

    // Don't show lock text after delivery
    if (shipmentStatus === 'delivered') {
      return false;
    }

    const status =
      item?.shippingStatus?.toLowerCase() ||
      item?.orderStatus?.toLowerCase();

    return status === 'item_packed' ||
          status === 'packed' ||
          status === 'on_the_way' ||
          status === 'on the way'; 
  }
  cancelItem(item: any) {  
    console.log('ITEM RECEIVED', item);
    const payload = {
      garageKey: localStorage.getItem('garageKey'),
      orderKey: this.orderDetails?.orderKey,
      orderCancel: false,
      cancelItems: [
        {
          partNumber: item.partNumber,
          quantity: item.quantity
        }
      ]
    };
    this.aspLoadingService.show();
    console.log('Cancel Item Payload', payload);

    this.aspOrderListService.cancelOrder(payload)
      .subscribe({
        next: (res: any) => {
          this.aspLoadingService.hide();

        if (res.code === 200) {
          console.log('ITEM CANCEL RESPONSE', res);


          this.cancelledItemName = item.partName;
          this.showItemCancelSuccessPopup = true;
          console.log('showItemCancelSuccessPopup', this.showItemCancelSuccessPopup);
          this.toastr.success('Item cancelled successfully');
          // this.getOrderDetails(this.orderKey);

        } else {

          this.toastr.error(
            res?.data?.description ||
            res?.message ||
            'Failed to cancel item'
          );

        }

      },
        error: (err) => {
          console.error(err);
          this.toastr.error('Failed to cancel item');
        }
      });
  }
  cancelOrderCompletely() {
    const payload = {
      orderKey: this.orderDetails?.orderKey,
      orderCancel: true,
      cancelItems: []
    };

    console.log('Cancel Order Payload', payload);

    this.aspOrderListService.cancelOrder(payload)
      .subscribe({
        next: (res: any) => {
          console.log('Cancel Order Response', res);

          this.toastr.success('Order cancelled successfully');
          this.getOrderDetails(this.orderKey);
        },
        error: (err) => {
          console.error('Cancel Order Error', err);
          this.toastr.error('Failed to cancel order');
        }
      });
  }

//   openCancelItemPopup(item: any) {
//      alert('openCancelItemPopup hit');

//   const cancellableItems = this.orderDetails?.orderItems?.filter((x: any) =>
//     this.canShowCancelItem(x)
//   ) || [];

//   console.log('Cancellable Items', cancellableItems);
//   console.log('Length', cancellableItems.length);

//   if (cancellableItems.length === 1) {
//     console.log('Opening last item popup');

//     this.lastItemName = item.partName;
//     this.selectedCancelItem = item;

//     this.showLastItemDeletePopup = true;
//     console.log('showLastItemDeletePopup', this.showLastItemDeletePopup);

//     return;
//   }

//   this.selectedCancelItem = item;
//   this.showCancelItemPopup = true;
// }
openCancelItemPopup(item: any) {

  // Show last-item popup only when order has exactly 1 item
  if (this.orderDetails?.orderItems?.length === 1) {

    this.lastItemName = item.partName;
    this.selectedCancelItem = item;

    this.showLastItemDeletePopup = true;
    return;
  }

  // Otherwise cancel item directly
  this.cancelItem(item);
}
// openCancelItemPopup(item: any) {

//   const cancellableItems = this.orderDetails?.orderItems?.filter(
//     (x: any) => this.canShowCancelItem(x)
//   ) || [];

//   console.log('Cancellable Items', cancellableItems);
//   console.log('Length', cancellableItems.length);

//   // Last item remaining
//   if (cancellableItems.length === 1) {

//     this.lastItemName = item.partName;
//     this.selectedCancelItem = item;

//     this.showLastItemDeletePopup = true;

//     return;
//   }

//   // Directly cancel item
//   this.cancelItem(item);
// }
confirmDeleteLastItem() { 

  this.showLastItemDeletePopup = false;

  // cancel entire order instead of item
  this.cancelEntireOrder();
}
closeLastItemDeletePopup() {
  this.showLastItemDeletePopup = false;
}
  // confirmCancelItem() {  alert('confirmCancelItem hit');
  //   if (this.selectedCancelItem) {
  //     this.cancelItem(this.selectedCancelItem);
  //   }

  //   this.showCancelItemPopup = false;
  // }
  openLockedItemPopup(item: any) {
    this.selectedLockedItem = item;
    this.isLockedPopupOpen = true;
  }

  closeLockedPopup() {
    this.isLockedPopupOpen = false;
    this.selectedLockedItem = null;
  }
  closeItemCancelSuccessPopup() {
    this.showItemCancelSuccessPopup = false;
    this.aspLoadingService.show();
     this.isVisible = false;
    window.location.reload();
  }


  getPriceDetails() {
    if (this.selectedDelivery === 'To Be Delivered') {
      return {
        totalPrice: this.orderDetails?.toBeDeliveredPrices?.totalPrice || 0,
        discount: this.orderDetails?.toBeDeliveredPrices?.totalDiscount || 0,
        shippingCharges: 0
      };
    }

    if (this.selectedDelivery?.startsWith('DELIVERY')) {
      const delivery = this.deliveryData[this.selectedDelivery];

      return {
        totalPrice: delivery?.totalPrice || this.orderDetails.grandTotal,
        discount: delivery?.discount || this.orderDetails.discount,
        shippingCharges: delivery?.shippingCharges || 0
      };
    }

    return {
      totalPrice: this.orderDetails.grandTotal,
      discount: this.orderDetails.discount,
      shippingCharges: this.orderDetails.shippingCharges
    };
  }
}
